import { Box } from "@mui/material";

import { useOrderContext } from "contexts/OrderContext";
import ContentCard from "Components/shared/ContentCard";
import { useRTL } from "hooks/isRTL";
import formatPhoneNumber from "utils/formatPhoneNumber";
import { fallbackValue } from "constants/fallbackConstant";

/**
 * Displays detailed information about the receiver of the order.
 */
const ReceiverDetailsTab = () => {
  const { receiverDetails,orderDetails, receiverLoading, receiverError } = useOrderContext();

  const { t } = useRTL();

  if (receiverLoading) return <p>Loading receiver details...</p>;
  if (receiverError) return <p>Error loading receiver details.</p>;

  const content = [
    { label: t("receiverName"), value: receiverDetails?.fullName || fallbackValue },
    { label: t("receiverPhoneNumber"), value: formatPhoneNumber(receiverDetails?.phoneNumber) || fallbackValue },
    {
      label: t("secondaryPhoneNumber"),
      value: formatPhoneNumber(receiverDetails?.secondaryPhoneNumber) || fallbackValue,
    },
    {
      label: t("receiverWhatsappNumber"),
      value: formatPhoneNumber(orderDetails?.receiverWhatsApp) || fallbackValue,
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "1rem",
        padding: "1rem",
      }}
    >
      <ContentCard title={t("receiverDetails")} content={content} />

      <Box
        sx={{
          visibility: "hidden",
        }}
      >
        <ContentCard title="" content={[]} />
      </Box>
    </Box>
  );
};

export default ReceiverDetailsTab;
